import { createFileRoute } from '@tanstack/react-router';
import { SettingsProfile } from '@/pages';

/**
 * Settings Profile Route (Protected)
 * Profile update — name and avatar
 */
export const Route = createFileRoute('/_authenticated/settings/profile')({
  component: SettingsProfile,
});
